// AudioEngine contract (§25). Frozen after WP0: additive changes only (WP8 added the optional
// `EngineOptions` argument of the factory). The implementation is audio/Engine.ts.
import type { MapId, ModeId } from '@shared/ids';
import type { FrameView } from '../game/FrameView';
import type { Settings } from '../profile/settings';
import { Engine, type EngineOptions } from './Engine';

export type { EngineOptions } from './Engine';

export type UiSound = 'hover' | 'click' | 'back' | 'error' | 'coin' | 'drumroll' | 'cardFlip' | 'toast';

export interface AudioEngine {
  unlock(): Promise<void>;             // called from first user gesture
  readonly unlocked: boolean;
  setVolumes(v: Settings['audio']): void;
  setRound(info: { mapId: MapId; modeId: ModeId; golden: boolean; roundIndex: number; startRoomTick: number }): void;
  setMenu(on: boolean): void;          // lounge theme in menus
  update(view: FrameView): void;       // music clock, adaptive layers, loops (teeter, sweeper hum, pinball rumble, cup whirl, potato beeps), crowd, panning
  playUi(id: UiSound): void;
  preview(kind: 'honk' | 'scream', id: number): void;
  readonly captions: { text: string; until: number }[];   // for sound captions UI
}

/**
 * The WP8 engine (§13, §25). `opts` is additive: the bus carries sim events, replays and the
 * gamepad unlock; `project` (Renderer.worldToScreen) gives §13.1 screen-space panning. Without
 * them the engine still plays UI sounds, previews and music, and pans from world x.
 */
export function createAudioEngine(opts: EngineOptions = {}): AudioEngine {
  return new Engine(opts);
}
